import React from "react";

import useModalStore from "@/stores/modal";
import useUxStore from "@/stores/ux";

const useHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [searchModalMode, setSearchModalMode] = React.useState("location");
  const setUx = useUxStore((state) => state.set);

  const toggleMobileNav = React.useCallback(() => {
    setUx({ showMetaBar: false });
    if (!isMenuOpen) {
      setIsMenuOpen(true);
      document.body.classList.add("mobile-nav-open");
    } else {
      setIsMenuOpen(false);
      document.body.classList.remove("mobile-nav-open");
    }
  }, [isMenuOpen]);

  const { isSearchOpen, closeSearchModal, openSearchModal } = useModalStore((state) => ({
    isSearchOpen: state.modal?.type === "search",
    openSearchModal: () => state.openModal("search"),
    closeSearchModal: () => state.closeModal("search"),
  }));

  return {
    isMenuOpen,
    setIsMenuOpen,
    toggleMobileNav,
    isSearchOpen,
    closeSearchModal,
    openSearchModal,
    searchModalMode,
    setSearchModalMode,
  };
};

export default useHeader;
